import Axios from 'axios';
import Cookie from 'js-cookie';
import { MessageBox, Message } from 'element-ui';
import router from '@/router/index';
const request = Axios.create({
    timeout: 1000 * 10
});
// 请求拦截
request.interceptors.request.use(config => {
    config.headers['x-platform'] = 'desktop';
    return config;
});
// 响应拦截 —— 与 admin 的 http.js 行为保持一致
request.interceptors.response.use(async (response) => {
    const contentType = response.headers['content-type'] || '';
    // JSON 响应
    if (contentType.indexOf('application/json') === 0) {
        // blob 请求返回了 JSON，说明有错误
        if (response.config.responseType === 'blob') {
            const text = await response.data.text();
            const resp = JSON.parse(text);
            Message.error((resp.error && resp.error.message) || 'Export failed');
            return Promise.reject(resp);
        }
        if (!response.data.success) {
            const error = response.data.error;
            const errorCode = error && error.code;
            // 登录失效
            if ([400, 4001, 11001].includes(+errorCode)) {
                MessageBox.alert(error.message || 'Error', 'Error', {
                    type: 'error',
                    callback: () => {
                        Cookie.remove('isLogin');
                        router.push({ name: 'login' });
                    }
                });
                return Promise.reject('');
            }
            Message.error((error && error.message) || 'Unknown error');
            return Promise.reject(response.data);
        }
        // 成功：返回 response.data（即 { success: true, result: {...} }）
        return response.data;
    }
    // 非 JSON（blob 文件下载等）：返回完整 response
    return response;
}, error => {
    const response = error.response;
    if (response) {
        Message.error((response.data && response.data.error && response.data.error.message) || response.statusText);
    }
    return Promise.reject(error);
});
export default request;
